import { cuartApi } from 'Api/axios'

const formattedErrorString = errorObject =>
  Object.entries(errorObject)
    .map(([key, value]) => `${key}: ${value}`)
    .join('\n')

export const postLoginService = async () => {
  try {
    const { headers, status } = await cuartApi.post(`/client/login`, {
      collect_user: {
        email: process.env.REACT_APP_CUART_EMAIL,
        password: process.env.REACT_APP_CUART_PASSWORD,
      },
    })

    if (status === 200) {
      const token = headers.authorization
      return token
    } else {
      throw new Error()
    }
  } catch (error) {
    console.error('Error en login:', error)
    throw error
  }
}

export const getLockersService = async () => {
  const { status, data } = await cuartApi.get(`/machines`)

  if (status === 200) {
    return data
  }

  throw new Error('Erro al obtener los lockers')
}

export const getSlotsByLockerService = async lockerId => {
  const { status, data } = await cuartApi.post(`/slot_list`, {
    machine_id: lockerId,
    state_id: 3,
  })

  if (status === 200) {
    return data
  }

  throw new Error('Erro al obtener los slock del locker')
}

export const updateSlotService = async (
  slotId,
  {
    customerName,
    customerDocument,
    customerEmail,
    customerCellphone,
    orderNumber,
    description,
  }
) => {
  try {
    const { status, data } = await cuartApi.put(`/slots/${slotId}`, {
      cc_name: customerName,
      cc_document: customerDocument,
      cc_email: customerEmail,
      cc_cellphone: customerCellphone,
      order_number: orderNumber,
      cc_description: description,
    })

    if (status === 200) {
      const errorMessage = data.message
      if (errorMessage) {
        throw new Error(
          `Error al reservar el slot:\n${formattedErrorString(errorMessage)}`
        )
      }

      return data
    }
  } catch (error) {
    const { status, data } = error.response || {}

    if (status === 400 && data) {
      throw new Error(
        `Error al reservar el slot:\n${formattedErrorString(data)}`
      )
    }

    // Si no es un error 400, lanzar el error como está
    throw error
  }
}

cuartApi.interceptors.request.use(config => {
  const token = window.localStorage.getItem('autorizationCuart') || ''

  if (token) {
    config.headers = {
      ...config.headers,
      Authorization: token,
    }
  }
  return config
})
